import { render, staticRenderFns } from "./SoilType.vue?vue&type=template&id=36fa836c&scoped=true&"
import script from "./SoilType.vue?vue&type=script&lang=js&"
export * from "./SoilType.vue?vue&type=script&lang=js&"
import style0 from "./SoilType.vue?vue&type=style&index=0&id=36fa836c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa836c",
  null
  
)

export default component.exports